import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import PushPinIcon from "@mui/icons-material/PushPin";
import {useEffect } from "react";
import "./PinnedMSgNotification.css";

function PinnedMSgNotification({setShowPinned, title}) {
  useEffect(() => {}, [title]);
  
  return (
    <>
      <Box className="py-2 w-100 d-flex border-top border-bottom cursor-pointer" px={3} mr={-3} onClick={() => setShowPinned(true)}>
        <Box mr={2}>
          <div className="pin-bullet"></div>
          <div className="pin-bullet"></div>
          <div className="pin-bullet"></div>
          <div className="pin-bullet"></div>
        </Box>
        <Box className="d-flex w-100 align-items-center gap-2">
          <Box>
            <Box>
              <Typography
                variant="body2"
                className="text-truncate fw-semibold"
                sx={{
                  color: "#2a93db",
                  maxWidth: "calc(100% - 130px)",
                }}
              >
                <PushPinIcon
                  style={{
                    width: "1rem",
                    height: "1rem",
                    color: "#2a93db",
                  }}
                />
                Pinned Messages
              </Typography>
            </Box>
            <Box className="ps-1">
              <Typography
                variant="body2"
                className="text-truncate fw-semibold"
                sx={{
                  maxWidth: "calc(100% - 130px)",
                }}
              >
                {title}
              </Typography>
              
            </Box>
          </Box>
          <Box>
            <PushPinIcon style={{}} />
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default PinnedMSgNotification;
